import '../../css/pages/special_list.less'
import '../../css/pages/shanxishangmao_resourceTopic.less'
import xss from 'xss';
new Vue({
    el: "#app",
    data: function () {
        return {
            prefix,
            subjectId,
            bannerPlateType,
            headActive: true,
            scrollNavStatus: true,//开启页面滚动监听控制导航样式
            showMore: {
                hasMore: true,
                active: false,
                maxIndex: 0,
                ready: false
            },
            tagList: thematicNames,
            specialStyle: null,//系列专题样式，1-产品、2、川大
            titleArr: '系列专题'.split(''),
        };
    },
    directives: {
        show_more: {
            componentUpdated: (el, binding, vnode) => {
                //初始化完成及不监听了
                if (binding.value.ready) return
                console.log('更新')
                let maxRow = parseInt(el.getAttribute('data-row') || 1)
                let rowHeight = 54
                let maxHeight = maxRow * rowHeight
                let currHeight = el.clientHeight
                let valueEl = jQuery(el).find('.value')
                let tabsNum = valueEl.length
                // console.log('tabsNum',tabsNum,'currHeight',currHeight)

                if (currHeight > (maxHeight + rowHeight / 2)) {
                    //超出设置行数
                    // console.log('超出了')
                    binding.value.maxIndex--
                    binding.value.ready = true
                    // binding.value.active = false
                    valueEl.each((i, e) => {
                        if (jQuery(e).hasClass('active')) {
                            binding.value.activeIndex = i
                            if (i > binding.value.maxIndex) {
                                binding.value.active = true
                            } else {
                                binding.value.active = false
                            }
                        }
                    })
                } else if (!binding.value.ready && binding.value.maxIndex < tabsNum) {
                    binding.value.maxIndex++
                } else {
                    binding.value.hasMore = false
                }
                // console.log('maxIndex',binding.value.maxIndex)
            }
        }
    },
    watch: {
        sysModules: {
            handler(newVal) {
                console.log(newVal)
                if (newVal && newVal.length) {
                    let specialStyle = (newVal.find(el => el.code == 'series_features_style') || {}).value
                    this.specialStyle = specialStyle
                    let specialSubjectTitle = (newVal.find(el => el.code == 'special_subject_title') || {}).value
                    if (specialSubjectTitle) {
                        this.titleArr = specialSubjectTitle.split('')
                        document.title = document.title.replace('系列专题', specialSubjectTitle)
                    }
                }
            },
            deep: true,
        }
    },
    mounted() {
        const that = this
        window.addEventListener('resize', function () {
            //重新计算tab栏
            that.showMore.hasMore = true
            that.showMore.ready = false
        })
        if (this.bannerPlateType == 3 || this.bannerPlateType == 4) {
            //省平台标题定制
            if (this.bannerPlateType == 3) {
                this.titleArr = '思政育人'.split('')
            } else if (location.pathname.includes('/case/center')) {
                this.titleArr = '案例中心'.split('')
            } else {
                this.titleArr = '系列专题'.split('')
            }
        }
    },
    methods: {
        handleTagChange(val) {

        }
    },
});
